import { mollieCredentialSupportsManagedNextGen } from "../../../../ingestion/config.ts";
import type { BillingProviderBinding } from "../types.ts";
import type { BillingWebhookManagementCapability } from "../types.ts";

export function resolveMollieWebhookManagementCapability(
	binding: BillingProviderBinding,
): BillingWebhookManagementCapability {
	const live = binding.credentials.live;
	const test = binding.credentials.test;
	const kind = live?.kind ?? test?.kind;
	if (kind === "api_key" || kind === "secret_key" || kind === "restricted_key") {
		return {
			classic: true,
			nextGen: {
				available: false,
				reason: "api_key_classic_only",
			},
		};
	}
	if (mollieCredentialSupportsManagedNextGen(kind)) {
		return {
			classic: true,
			nextGen: { available: true },
		};
	}
	return {
		classic: true,
		nextGen: {
			available: false,
			reason: "credential_missing_webhooks_write",
		},
	};
}
